import type { RouteRecordRaw } from 'vue-router'

declare module 'vue-router' {
  interface RouteMeta {
    /** 页面标题 */
    title?: string
    /** 是否需要登录 */
    requiresAuth?: boolean
    /** 是否缓存页面 */
    keepAlive?: boolean
  }
}

export const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/home/index.vue'),
    meta: { title: '首页' },
  },
  {
    path:'/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '验证码登录' },
  },
  {
    path:'/other_login',
    name: 'OtherLogin',
    component: () => import('@/views/otherLogin/index.vue'),
    meta: { title: '密码登录' },
  },
  {
    path: '/riskAssessment/questions',
    name: 'RiskAssessmentQuestions',
    component: () => import('@/views/riskAssessment/questions.vue'),
    meta: { title: '风险测评' },
  },
  {
    path: '/riskAssessment/success',
    name: 'RiskAssessmentSuccess',
    component: () => import('@/views/riskAssessment/success.vue'),
    meta: { title: '风险测评' },
  },
  {
    path: '/riskAssessment/fail',
    name: 'RiskAssessmentFail',
    component: () => import('@/views/riskAssessment/fail.vue'),
    meta: { title: '风险测评' },
  },
  {
    path: '/realNameVerify/home',
    name: 'RealNameVerifyHome',
    component: () => import('@/views/realNameVerify/home.vue'),
    meta: { title: '身份认证' },
  },
  {
    path: '/realNameVerify/choice',
    name: 'RealNameVerifyChoice',
    component: () => import('@/views/realNameVerify/choice.vue'),
    meta: { title: '身份认证' },
  },
  {
    path: '/realNameVerify/uploadFile',
    name: 'RealNameVerifyUploadFile',
    component: () => import('@/views/realNameVerify/uploadFile.vue'),
    meta: { title: '身份认证' },
  },
  {
    path: '/realNameVerify/identityConfirm',
    name: 'RealNameVerifyIdentityConfirm',
    component: () => import('@/views/realNameVerify/identityConfirm.vue'),
    meta: { title: '身份认证' },
  },
  {
    path: '/agreementConfirm/home',
    name: 'AgreementConfirmHome',
    component: () => import('@/views/agreementConfirm/home.vue'),
    meta: { title: '协议确认' },
  },
  {
    path: '/agreementConfirm/detail',
    name: 'AgreementConfirmDetail',
    component: () => import('@/views/agreementConfirm/detail.vue'),
    meta: { title: '协议详情' },
  },
  {
    path: '/agreementConfirm/teacher',
    name: 'AgreementConfirmTeacher',
    component: () => import('@/views/agreementConfirm/teacher.vue'),
    meta: { title: '投资顾问资质' },
  },
  {
    path: '/agreementConfirm/unconfirm',
    name: 'AgreementConfirmUnconfirm',
    component: () => import('@/views/agreementConfirm/unconfirm.vue'),
    meta: { title: '协议确认' },
  },
  {
    path: '/agreementConfirm/highRisk',
    name: 'AgreementConfirmHighRisk',
    component: () => import('@/views/agreementConfirm/highRisk.vue'),
    meta: { title: '协议确认' },
  },
  {
    path: '/agreementConfirm/signStatement',
    name: 'AgreementConfirmSignStatement',
    component: () => import('@/views/agreementConfirm/signStatement.vue'),
    meta: { title: '签署协议' },
  },
  {
    path: '/agreementConfirm/signName',
    name: 'AgreementConfirmSignName',
    component: () => import('@/views/agreementConfirm/signName.vue'),
    meta: { title: '签字', requiresAuth: true },
  },
  {
    path: '/agreementConfirm/universal',
    name: 'AgreementConfirmUniversal',
    component: () => import('@/views/agreementConfirm/universal.vue'),
    meta: { title: '协议详情' },
  },
  {
    path: '/activeStatus/home',
    name: 'ActiveStatusHome',
    component: () => import('@/views/activeStatus/home.vue'),
    meta: { title: '激活结果', requiresAuth: true },
  },
  {
    path: '/activeStatus/activeResult',
    name: 'ActiveStatusActiveResult',
    component: () => import('@/views/activeStatus/activeResult.vue'),
    meta: { title: '激活进度', requiresAuth: true },
  },
  {
    path: '/activeStatus/agreement',
    name: 'ActiveStatusAgreement',
    component: () => import('@/views/activeStatus/agreement.vue'),
    meta: { title: '签署协议', requiresAuth: true },
  },
  {
    path: '/submitOrder/selfPay',
    name: 'SubmitOrderSelfPay',
    component: () => import('@/views/submitOrder/selfPay.vue'),
    meta: { title: '提交订单', requiresAuth: true },
  },
  {
    path: '/submitOrder/selfResult',
    name: 'SubmitOrderSelfResult',
    component: () => import('@/views/submitOrder/selfResult.vue'),
    meta: { title: '支付结果', requiresAuth: true },
  },
  {
    path: '/submitOrder/selfSuccess',
    name: 'SubmitOrderSelfSuccess',
    component: () => import('@/views/submitOrder/selfSuccess.vue'),
    meta: { title: '支付完成', requiresAuth: true },
  },
  {
    path: '/questionnaire/question',
    name: 'QuestionnaireQuestion',
    component: () => import('@/views/questionnaire/question.vue'),
    meta: { title: '回访问卷', requiresAuth: true },
  },
  {
    path: '/questionnaire/result',
    name: 'QuestionnaireResult',
    component: () => import('@/views/questionnaire/result.vue'),
    meta: { title: '问卷结果', requiresAuth: true },
  },
  {
    path: '/submitOrder/singlePay',
    name: 'SubmitOrderSinglePay',
    component: () => import('@/views/submitOrder/singlePay.vue'),
    meta: { title: '提交订单', requiresAuth: true },
  },
  {
    path: '/submitOrder/polling',
    name: 'SubmitOrderPolling',
    component: () => import('@/views/submitOrder/polling.vue'),
    meta: { title: '支付确认中', requiresAuth: true },
  },
  {
    path: '/submitOrder/singleResult',
    name: 'SubmitOrderSingleResult',
    component: () => import('@/views/submitOrder/singleResult.vue'),
    meta: { title: '支付结果', requiresAuth: true },
  },
  {
    path: '/emptyPage',
    name: 'EmptyPage',
    component: () => import('@/views/emptyPage/index.vue'),
    meta: { title: '暂无内容' },
  },
  {
    path: '/saleEnded',
    name: 'SaleEnded',
    component: () => import('@/views/saleEnded/index.vue'),
    meta: { title: '活动提示' },
  },
  {
    path: '/no_friend',
    name: 'NoFriend',
    component: () => import('@/views/noFriend/index.vue'),
    meta: { title: '请您先添加专属客服' },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/error/404.vue'),
    meta: { title: '页面不存在' },
  },
]

export default routes
